{
    "Routes.error.pageNotFound": "Page Not Found.",
    "Routes.error.home": "Home.",
    "Routes.error.accessDenied": "Access Denied.",
    "Routes.error.unknownError": "Unknown Error!"
}
